/**
 * @param {string} priceForCurrentLevel - discounted price.
 * @param {string} minPrice - minimum price
 * @returns {string} employee hover price wrapper HTML
 */
export default (priceForCurrentLevel, minPrice) =>
    `<span class="price-promotion">
         ${priceForCurrentLevel}
     </span>
     <span class="price-strike">
         ${minPrice}
     </span>
`;
